/**
 * Local, fake auth for the demo customer portal.
 *
 * The portal is intentionally decoupled from the real `AuthContext`: it has its
 * own login at `/portal/login` and gates `/portal/*` on a sessionStorage flag.
 * This is demo-only scaffolding — there is no real credential check, token, or
 * backend session. Mirrors the lightweight flag pattern in `src/demo/im`.
 */

const SESSION_KEY = 'portal-session';

/** Canned credentials accepted by the portal login form. */
export const PORTAL_CREDENTIALS = {
  email: 'noam@gently-ai.com',
  password: 'password',
} as const;

/** True when the portal "session" flag is set for this browser tab. */
export function isPortalLoggedIn(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Set or clear the portal "session" flag. */
export function setPortalLoggedIn(loggedIn: boolean): void {
  try {
    if (loggedIn) {
      window.sessionStorage.setItem(SESSION_KEY, 'true');
    } else {
      window.sessionStorage.removeItem(SESSION_KEY);
    }
  } catch {
    // sessionStorage unavailable — ignore (demo-only).
  }
}

/** Clear the portal "session" (used by Log out). */
export function clearPortalSession(): void {
  setPortalLoggedIn(false);
}

/** Validate submitted credentials against the canned pair (trimmed). */
export function portalCredentialsValid(
  email: string,
  password: string,
): boolean {
  return (
    email.trim().toLowerCase() === PORTAL_CREDENTIALS.email &&
    password === PORTAL_CREDENTIALS.password
  );
}
